export const normDigitBlocks = (n = 4, sep = ' ', count = 4, digit = '0-9') => {
  const innerNonDigists = new RegExp(`[^${digit}${sep}]+|${sep}(?=${sep})`, 'g');
  const innerDigitBlock = new RegExp(`([${digit}]{${n}})(?!${sep}|$)`, 'g');
  const extraBlock = new RegExp(`(?<=[^${sep}]+(${sep}[^${sep}]+){${count - 1}})${sep}.*$`);
  return (value = '') => value.replace(innerNonDigists, '').replace(innerDigitBlock, `$1${sep}`).replace(extraBlock, '');
};
